import { FunctionComponent, JSX, RefAttributes, createElement, forwardRef, useMemo } from "react";

// -------------------------------------------------------------------------------------------------
// #region Hook
// -------------------------------------------------------------------------------------------------

const useWithForwardRef = <TProps extends {}, TRef>(Component: FunctionComponent<TProps>) =>
    useMemo(
        () =>
            forwardRef<TRef, TProps>((props, ref) =>
                createElement(Component, { ...props, ref } as TProps)
            ) as unknown as (props: TProps & RefAttributes<TRef>) => JSX.Element,
        [Component]
    );

// #endregion Hook

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { useWithForwardRef };

// #endregion Exports
